import React from "react";
import "leaflet/dist/leaflet.css";

import PageHero from "../../components/common/PageHero";
import PageSectionHeader from "../../components/common/PageSectionHeader";
import ScrollIndicator from "../Home/ScrollIndicator";
import useScrollToTop from "../../hooks/useScollToTop";

import CarteDetailsPanel from "./components/CarteDetailsPanel";
import CarteFilters from "./components/CarteFilters";
import CarteInteretsMap from "./components/CarteInteretsMap";
import CarteSkeleton from "./components/CarteSkeleton";

import { CARTE_INTERETS_PAGE } from "./data/carteInteretsUiData";
import { useCarteInteretsPage } from "./hooks/useCarteInteretsPage";

export default function CarteInteretsPage() {
  useScrollToTop();

  const {
    loading,
    error,
    points,
    selectedPoint,
    filters,
    stats,
    updateSearch,
    toggleType,
    resetFilters,
    selectPoint,
    refresh,
  } = useCarteInteretsPage();

  return (
    <>
      <PageHero
        title={CARTE_INTERETS_PAGE.title}
        imageUrl={CARTE_INTERETS_PAGE.heroImageUrl}
        crumbs={CARTE_INTERETS_PAGE.crumbs}
      />

      <ScrollIndicator />

      <main className="mx-auto max-w-[1240px] px-4 pb-16 pt-6 sm:px-6 md:pt-8">
        <PageSectionHeader
          eyebrow={CARTE_INTERETS_PAGE.eyebrow}
          title={CARTE_INTERETS_PAGE.title}
          description={CARTE_INTERETS_PAGE.description}
        >
          <div className="rounded-3xl border border-slate-200 bg-white/80 px-5 py-4 shadow-sm backdrop-blur dark:border-slate-800 dark:bg-slate-950/70">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
              Lieux référencés
            </p>
            <p className="mt-1 text-3xl font-bold text-slate-950 dark:text-white">
              {loading ? "…" : stats.total}
            </p>
            <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
              point{stats.total > 1 ? "s" : ""} sur la carte
            </p>
          </div>
        </PageSectionHeader>

        <div className="mt-5">
          <CarteFilters
            loading={loading}
            filters={filters}
            stats={stats}
            onSearch={updateSearch}
            onToggleType={toggleType}
            onReset={resetFilters}
            onRefresh={refresh}
          />
        </div>

        {error && (
          <div className="mt-5 rounded-3xl border border-red-200 bg-red-50 px-5 py-4 text-sm font-semibold text-red-700 dark:border-red-900/60 dark:bg-red-950/30 dark:text-red-300">
            Une erreur est survenue pendant le chargement des lieux d’intérêt.
          </div>
        )}

        <section className="mt-6">
          {loading ? (
            <CarteSkeleton />
          ) : (
            <div className="grid gap-6 lg:grid-cols-[minmax(0,1.45fr)_minmax(360px,0.85fr)] lg:items-start">
              <CarteInteretsMap
                loading={loading}
                points={points}
                selectedPoint={selectedPoint}
                onSelectPoint={selectPoint}
              />

              <CarteDetailsPanel
                loading={loading}
                point={selectedPoint}
                points={points}
                onSelectPoint={selectPoint}
              />
            </div>
          )}
        </section>
      </main>
    </>
  );
}